import { useProgressStore } from '~/store/progress'
import { useUserStore } from '~/store/user'
import { useQuestionsStore } from '~/store/questions'

export default defineNuxtRouteMiddleware(async (to, from) => {
  const nuxtApp = useNuxtApp()
  const { $pinia } = nuxtApp

  const progressStore = useProgressStore($pinia)
  const questionsStore = useQuestionsStore($pinia)
  const piniaUserStore = useUserStore($pinia)

  let type = to.query?.type || progressStore.currentApp.type
  const req = nuxtApp?.ssrContext?.event?.node?.req
  const cypressUser = process.server && req && req.headers['user-agent'] == 'lendioCypressTestUser'

  const routeWithTokensRemoved = await piniaUserStore.extractUserProfile(to)
  if (routeWithTokensRemoved) {
    to = routeWithTokensRemoved
  }

  if (!piniaUserStore.hasOptimusUser || cypressUser) {
    return
  }

  await Promise.allSettled([
    progressStore.updateApplication({ type }),
    progressStore.executeRequiredActions({ appName: type }),
    type === 'marketplace'
      ? questionsStore.initializeInfoPage()
      : null
  ])
})
